import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hideOwns'
})
export class OwnedFilter implements PipeTransform {
	transform(value: any, args?: any): any {
		if (value==null) return value;
		if (!args) return value;
		let results = [];

		// Each product
		let productFilter = value.filter(product => {
			if ( product.owns == 0 )
				results.push(product);
		});

		return results;
	}
}


// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/pipes/owned.pipe.ts